import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/phone-forward.vue
var o = {
	name: "DtIconPhoneForward",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--phone-forward"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Phone Forward",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M8.646.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 1 1-.708-.708L9.793 3.5H7a.5.5 0 0 1 0-1h2.793L8.646 1.354a.5.5 0 0 1 0-.708ZM2.01 2.034a.036.036 0 0 0-.002.016 7.98 7.98 0 0 0 .554 2.508l1.128-.94a.125.125 0 0 0 .041-.127l-.349-1.396A.125.125 0 0 0 3.26 2H2.083a.092.092 0 0 0-.065.023.035.035 0 0 0-.009.011Zm.992 3.459L4.33 4.385c.332-.276.476-.718.371-1.136l-.349-1.397A1.125 1.125 0 0 0 3.26 1H2.083c-.577 0-1.106.457-1.074 1.1a9.101 9.101 0 0 0 2.674 5.94c2.217 2.22 4.922 2.773 6.137 2.912.67.077 1.18-.463 1.18-1.077V8.738c0-.516-.352-.966-.853-1.091l-1.439-.359a1.125 1.125 0 0 0-1.068.296L6.394 8.832A8.804 8.804 0 0 1 4.39 7.334 8.226 8.226 0 0 1 3 5.493Zm4.35 3.796a9.892 9.892 0 0 0 2.583.67.05.05 0 0 0 .023-.002.046.046 0 0 0 .017-.01.096.096 0 0 0 .026-.072V8.738a.125.125 0 0 0-.095-.121l-1.439-.359a.125.125 0 0 0-.118.033l-.997.998Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=phone-forward.js.map